import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba años buscando algo que entendiera lo que vivimos después de los 50. A los 10 días ya tenía claridad mental y energía estable. Hoy me siento como yo otra vez.',
  name: 'María Elena R.',
  age: '54 años · Colombia'
}];
export const TestimonialsSection = () => {
  return <Section bg="bg-cream-light" data-id="element-312">
      <FadeIn data-id="element-313">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-314">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-brown mb-4 leading-tight" data-id="element-315">
            Mujeres reales.{' '}
            <span className="text-gold italic font-normal" data-id="element-316">
              Cambios reales.
            </span>
          </h2>
          <p className="text-lg text-brown-light" data-id="element-317">
            Aquí van sus palabras exactas.
          </p>
        </div>
      </FadeIn>

      <StaggerContainer className="max-w-2xl mx-auto" data-id="element-318">
        {testimonials.map((testimonial, idx) => <StaggerItem key={idx} data-id="element-319">
            <div className="bg-white border border-cream-dark rounded-3xl p-8 md:p-10 shadow-md flex flex-col" data-id="element-320">
              <div className="flex gap-1 mb-5" data-id="element-321">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-322" />)}
              </div>
              <p className="text-brown-light leading-relaxed italic flex-1 mb-6" data-id="element-323">
                "{testimonial.quote}"
              </p>
              <div data-id="element-324">
                <p className="font-bold text-brown text-lg" data-id="element-325">
                  {testimonial.name}
                </p>
                <p className="text-brown-light text-sm" data-id="element-326">{testimonial.age}</p>
              </div>
            </div>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
};